import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatGridListModule } from '@angular/material/grid-list';
import { BrowserModule } from '@angular/platform-browser';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateService } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './modules/navbar/navbar.component';
import { SectionsComponent } from './modules/sections/sections.component';
import { Globals } from './shared/utils/globals';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './modules/shared/shared.module';
import { MappTranslateModule } from './modules/shared/mapp-translate.module';
import { HttpRequestInterceptor } from './core/interceptors/HttpRequest.interceptor';
import { MarkdownModule, MarkedOptions, MarkedRenderer } from 'ngx-markdown';
import { RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStrategy } from './CustomRouteReuseStrategy';
import './shared/extensions/stringExtensions';

// function that returns `MarkedOptions` with renderer override
export function markedOptionsFactory(): MarkedOptions {
  const renderer = new MarkedRenderer();

  renderer.blockquote = (text: string) => {
    return '<blockquote class="blockquote"><p>' + text + '</p></blockquote>';
  };

  renderer.link = (href: string, title: string, text: string) => {
    return '<a href="' + href + '" target="_blank">' + text + '</a>';
  };

  return {
    renderer: renderer,
    gfm: true,
    breaks: false,
    pedantic: false,
    smartLists: true,
    smartypants: false,
  };
}

@NgModule({
  declarations: [AppComponent, NavbarComponent, SectionsComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    MappTranslateModule,
    MatGridListModule,
    NgSelectModule,
    FormsModule,
    MatSelectModule,
    BrowserAnimationsModule,
    MatTableModule,
    MatSortModule,
    MatDialogModule,
    MatFormFieldModule,
    MatTooltipModule,
    SharedModule,
    MarkdownModule.forRoot({
      loader: HttpClient,
      markedOptions: {
        provide: MarkedOptions,
        useFactory: markedOptionsFactory,
      },
    }),
  ],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: CustomRouteReuseStrategy,
    },
    Globals,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  public static defaultLang = 'en-EN';

  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang(AppModule.defaultLang);
  }
}
